/// <reference types="vite/client" />
/**
 * Бренд ЛК по хосту.
 *
 * Один и тот же admin-portal обслуживает два бренда:
 *   lk.hkeeper.ru / lk.resonline.ru → HKeeper (нейтральный модуль для PMS-партнёров);
 *   app.roomdesk.ru                 → RoomDesk (собственная PMS).
 * Разделение нужно, чтобы клиенты RoomDesk не видели бренд HKeeper и
 * наоборот (конфликт с PMS-партнёрами, см. docs/roomdesk-plan.md в api-server).
 *
 * Для проверки на dev: ?brand=roomdesk в URL (запоминается в sessionStorage).
 */
import hkeeperLogo from '../../views/login/logo_hkeeper.svg';
import roomdeskLogo from '../assets/logo_roomdesk.svg';

export type BrandId = 'hkeeper' | 'roomdesk';

export interface Brand {
  id: BrandId;
  /** Имя продукта в интерфейсе */
  name: string;
  /** Белый логотип для тёмных фонов */
  logo: string;
  /** Подпись под названием на экране входа */
  tagline: string;
  /** Публичный сайт */
  siteUrl: string;
  siteLabel: string;
  /** <title> вкладки */
  title: string;
  /** Контактный email поддержки (и для запросов по ПДн) */
  email: string;
}

const BRANDS: Record<BrandId, Brand> = {
  hkeeper: {
    id: 'hkeeper',
    name: 'HKeeper',
    logo: hkeeperLogo,
    tagline: 'Платформа для автоматизации отелей',
    siteUrl: 'https://hkeeper.ru',
    siteLabel: 'hkeeper.ru',
    title: 'HKeeper — Личный кабинет',
    email: 'mail@hkeeper.ru',
  },
  roomdesk: {
    id: 'roomdesk',
    name: 'RoomDesk',
    logo: roomdeskLogo,
    tagline: 'Облачная система управления отелем',
    siteUrl: 'https://roomdesk.ru',
    siteLabel: 'roomdesk.ru',
    title: 'RoomDesk — Личный кабинет',
    email: 'hello@roomdesk.ru',
  },
};

function detectBrandId(): BrandId {
  if (typeof window === 'undefined') return 'hkeeper';
  try {
    const q = new URLSearchParams(window.location.search).get('brand');
    if (q === 'roomdesk' || q === 'hkeeper') {
      window.sessionStorage.setItem('brand', q);
      return q;
    }
    const saved = window.sessionStorage.getItem('brand');
    if (saved === 'roomdesk' || saved === 'hkeeper') return saved;
  } catch {
    /* sessionStorage может быть недоступен — определяем по хосту */
  }
  return /(^|\.)roomdesk\.ru$/i.test(window.location.hostname) ? 'roomdesk' : 'hkeeper';
}

export const brand: Brand = BRANDS[detectBrandId()];
